import * as ng from 'angular';
import * as Linq from 'linq-es5';
import * as Core from '../../core';
import { ComponentRegistration } from '../../core';
import { ContentTypeSettingKeys, IContentTemplate, contentGroupType } from '../../data/interfaces';
import { ContentTemplate, IContentTemplateResource } from '../../data/content-template'
import { ContentTemplateWrite, IContentTemplateWriteResource } from '../../data/content-template-write'
import { ContentTypeSettings, IContentTypeSettingsResource } from '../../data/content-type-settings'
import { ICustomerSettingsService } from '../../services';

import { Quill } from 'quill';

let template = require('./content-editor.html');

class ContentEditorComponent extends ComponentRegistration {

    constructor() {
        super('contentEditor', {
            controller: ContentEditorController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IContentEditorController {
    onTemplateSelected(key: ContentTypeSettingKeys): void;
    onLanguageSelected(args: string): void;
    onEdit(args: any): void;
    onCancel(args: any): void;
    onSave(args: any): void;
}

class ContentEditorController implements IContentEditorController {
    private static $inject: Array<string> = ['$q', '$scope', '$rootRouter', 'ContentTemplate', 'ContentTypeSettings', 'ContentTemplateWrite', 'CustomerSettings'];

    private templateTitle: string;
    private activeTemplate: any;
    private templateSetting: any;
    private oriActiveTemplate: any;
    private isEditMode: boolean = false;
    private contentTemplates: Array<any> = [];
    private templateSettings: Array<any> = [];
    private templateTokens: Array<any> = [];
    private hideTokens: boolean = true;
    private editor: Quill;
    private hasTokens: boolean = false;
    private isEmailTemplate: boolean = false;
    private urlTemplateKey: ContentTypeSettingKeys;
    private _activeLanguage: string = "en";
    private get activeLanguage(): string {
        return this._activeLanguage;
    }
    private set activeLanguage(value: string) {
        if (value && value !== this._activeLanguage) {
            this._activeLanguage = value;
            this.setActiveTemplate();
        }

    }
    private get totalCharacter(): number {
        var cnt = 0;
        if (this.activeTemplate && this.activeTemplate.content) {
            cnt = this.activeTemplate.content.length;
        }
        return cnt;
    }
    private get maxContentLength(): string {
        var max = "unlimited";
        if (this.templateSetting && this.templateSetting.maxContentLength > 0) {
            max = this.templateSetting.maxContentLength;
        }
        return max;
    }


    private languages: Array<Core.ILanguage> = [];

    private config = {
        modules: {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],
                [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean'],                                         // remove formatting button
            ]
        }
    }

    constructor(private $q: ng.IQService,
        private $scope: ng.IScope,
        private $router: ng.Router,
        private ContentTemplate: IContentTemplateResource,
        private ContentTypeSettings: IContentTypeSettingsResource,
        private ContentTemplateWrite: IContentTemplateWriteResource,
        private CustomerSettings: ICustomerSettingsService) {
        console.log('ContentEditorController loading');
    }

    public $onInit() {
        console.log('ContentEditorController loaded');
        this.loadSettings().then((isLoaded) => {
            if (this.urlTemplateKey)
                this.onTemplateSelected(this.urlTemplateKey);
        });
    }

    public $routerOnActivate(next, previous) {
        // Get the page identified by the route parameter
        this.urlTemplateKey = next.params.id;

    }

    public navigate(address: Array<string>): void {
        this.$router.navigate(address);
    }

    public onEditorCreated(editor: any) {
        this.editor = editor;
    }


    public onTemplateSelected(key: ContentTypeSettingKeys): void {
        this.isEditMode = false;
        this.activeTemplate = undefined;
        this.templateSetting = Linq.From(this.templateSettings)
            .FirstOrDefault(x => x.key === key);
        this.templateTokens = this.templateSetting.templateTokens;
        this.hasTokens = this.templateTokens && this.templateTokens.length > 0;
        this.templateTitle = this.templateSetting.display;
        this.isEmailTemplate = this.templateSetting.groupType === contentGroupType.Email;
        this.setActiveTemplate();
    }

    public onLanguageSelected(args: any): void {
        console.log(args);
    }

    public onEdit(args: any): void {
        this.isEditMode = true;
    }

    public onCancel(args: any): void {
        this.isEditMode = false;
        if (this.oriActiveTemplate) {
            this.activeTemplate = ng.copy(this.oriActiveTemplate);
        }
    }

    public onSave(args: any): void {
        if (this.activeTemplate.isNew) {
            this.activeTemplate = this.ContentTemplateWrite.save(this.activeTemplate);
        }
        else {
            this.activeTemplate = this.ContentTemplateWrite.update(this.activeTemplate);
        }
        this.isEditMode = false;
    }

    public selected(item: any): boolean {
        return true;
    }

    public toggleTokens(): void {
        this.hideTokens = !this.hideTokens;
    }

    public onTokenSelected(args: any) {
        console.log(args);

        this.editor.insertText(this.getCurrentCursorPosition(), args)
    }

    public getCurrentCursorPosition() {
        var range = this.editor.getSelection();
        return range ? range.index + range.length : 0;
    }

    private loadSettings(): ng.IPromise<boolean> {
        let contentTypePromise = this.ContentTypeSettings.query({}).$promise
            .then((response) => {
                this.templateSettings = response;
            });
        let customerSettingsPromise = this.CustomerSettings.getLanguageSettings()
            .then((languageSettings) => {
                this.languages = languageSettings.languages;
            });

        return this.$q.all([contentTypePromise, customerSettingsPromise])
            .then(() => {
                return this.$q.resolve(true);
            });
    }

    private setActiveTemplate(): void {
        var key = this.templateSetting.key;
        var lang = this.activeLanguage;

        this.ContentTemplate.query({ key: key, languageCode: lang }).$promise
            .then((response) => {
                this.contentTemplates = response;
                this.activeTemplate = Linq.From(this.contentTemplates).FirstOrDefault(x => x.languageCode === this.activeLanguage);

                if (!this.activeTemplate) {
                    this.activeTemplate = {
                        'key': key,
                        'languageCode': this.activeLanguage,
                        'content': '',
                        'isNew': true
                    };
                }

                this.oriActiveTemplate = ng.copy(this.activeTemplate);

            })
            .catch((e) => {
                console.log(e);
            });
    }
}

let ceComponent = new ContentEditorComponent();
export default ceComponent;
export { ceComponent as ContentEditorComponent, IContentEditorController, ContentEditorController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/content-editor.ts